import jQuery from "jquery";
(function ($) {
    const $skipButton = $(".survey-skip");
    if (!$skipButton.length) return;
    $skipButton.on("click", (e) => {
        e.preventDefault();
        $("#pre-survey-text").hide();
        $("#pre-survey-subtext").hide();
        $("#post-survey-text").show();
        $(".survey-link").hide();
        $skipButton.hide();
    });
})(jQuery);
